<template>
  <div
    class="card"
    @click="handleClick"
    @keyup.enter="handleClick"
    :class="{ asLink: $listeners.click }"
  >
    <header>
      <h2 class="padd">{{ title | truncate(50) }}</h2>
    </header>

    <div class="image-holder">
      <div class="date-holder-lg" v-if="!default_image && date">
        <time>
          <span>{{ $dayjs(date).format("D") }}</span>
          <span>{{ $dayjs(date).format("MMM") }}</span>
        </time>
      </div>
      <image-loader
        v-else
        :image="default_image"
        :alt="title"
        style="min-width: 300px;"
      />
    </div>
    <footer>
      <p class="padd" v-if="subtitle">{{ subtitle }}</p>
      <date-with-icon
        :date="displayDate"
        v-else-if="displayDate"
        class="padd"
        :showIcon="true"
        :icon="iconToShow"
      ></date-with-icon>
      <date-with-icon
        :date="null"
        :title="`${likes} interested`"
        class="padd"
        show-icon
        icon="star--filled"
        v-if="likes"
      />
    </footer>
  </div>
</template>

<script>
import { Date as DateWithIcon, ImageLoader } from "@/components/elements";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: null,
    },
    default_image: {
      type: [Object, String],
      default: "",
    },
    date: [String, Date],
    created_time: {
      type: [String, Date],
      default: () => new Date(),
    },
    website_posted_date: {
      type: [String, Date, Number],
      default: () => new Date(),
    },
    website_url: String,
    id: Number,
    asLink: {
      type: Boolean,
      default: false,
    },
    self: String,
    likes: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    DateWithIcon,
    ImageLoader,
  },

  methods: {
    handleClick() {
      //are we a web url?
      if (this.website_url) {
        window.open(this.website_url);
        return;
      }
      // TODO: Do we need to return all the props that have been passed?
      this.$emit("click", this.id);
    },
  },

  computed: {
    displayDate() {
      if (this.date) {
        return this.date;
      }
      if (this.website_posted_date) {
        return this.website_posted_date;
      }

      return this.created_time;
    },
    contentType() {
      if (!this.self) {
        return "news";
      }
      const urlBits = this.self.split("/");
      if (urlBits.includes("content")) {
        return "content";
      } else if (urlBits.includes("event")) {
        return "event";
      } else {
        return "news";
      }
    },
    iconToShow() {
      if (this.contentType == "content") {
        return "book-open";
      } else if (this.contentType == "event") {
        return "calendar";
      } else {
        return "clock";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
  display: block;

  margin-bottom: 20px;

  position: relative;
  width: 100%;

  .padd {
    padding: 15px;
    margin: 0;
  }

  &.asLink {
    cursor: pointer;
    transition: all ease 0.3s;
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28);
      h2 {
        color: $colour-cactus-core-green;
      }
    }
  }

  header {
    height: 68px;

    h2 {
      line-height: 120%;
      transition: all ease 0.3s;
      margin: 0;
      font-weight: normal;
      font-size: 16px;
      width: 100%;
      max-height: 88px;
      text-overflow: ellipsis;
    }
  }

  img {
    max-width: 100%;
    margin: 0;
    width: 100%;
    // max-height: 200px;
  }

  .image-holder {
    height: 150px;
    @supports (object-fit: cover) {
      height: 180px;
    }
    overflow: hidden;
  }
}
.date-holder-lg {
  background: #e8edee;
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  time {
    align-self: center;
  }
  span {
    &:first-of-type {
      font-size: 30px;
    }
    display: block;
    width: 100%;
    color: #425563;
    font-size: 16px;
  }
}

footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
